export function initWebstoryArea(){
  (()=>{
    const root   = document.querySelector('.webstory');
    if (!root) return;

    const side   = root.querySelector('.webstory-side');
    const stripe = root.querySelector('.webstory-stripe');
    const parts  = [...root.querySelectorAll('.webstory-part')];
    const ctas   = [...root.querySelectorAll('.rail-cta')];
    const actionLinks = [...root.querySelectorAll('[data-webstory-action]')];
    const sectionScope = root.closest('[data-ani-section]');

    function clamp01(x){ return Math.min(1, Math.max(0, x)); }
    function easePow(x, g){ return Math.pow(x, g); }

    function openNavigatorOverlay(mode){
      const customEvent = new CustomEvent('website-navigator:open', {
        detail: {
          mode: String(mode || '').trim().toLowerCase() || undefined,
        },
      });
      window.dispatchEvent(customEvent);
      const overlay = document.getElementById('website-navigator-overlay');
      if (overlay && overlay.classList.contains('is-open')) return;
      const launcher = document.querySelector('.website-navigator-launcher');
      if (!(launcher instanceof HTMLElement)) return;
      launcher.click();
    }

    function bindActionLinks(){
      actionLinks.forEach((link) => {
        const action = link.getAttribute('data-webstory-action');
        if (action !== 'navigator') return;

        link.addEventListener('click', (event) => {
          event.preventDefault();
          const mode = link.getAttribute('data-webstory-mode');
          openNavigatorOverlay(mode);
        });
      });
    }

    function scrollToHashTarget(link){
      const hash = link.getAttribute('href') || '';
      if (!hash.startsWith('#') || hash.length < 2) return false;

      const target = document.getElementById(hash.slice(1));
      if (!target) return false;

      const y = Math.max(0, window.pageYOffset + target.getBoundingClientRect().top);
      const easing = (t) => 1 - Math.pow(1 - t, 3);

      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(y, { duration: 0.85, easing });
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      if (window.location.hash !== hash) {
        history.pushState(null, '', hash);
      }

      return true;
    }

    function bindHashLinks(){
      root.querySelectorAll('a[href="#how-we-work"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!scrollToHashTarget(link)) return;
          event.preventDefault();
        });
      });
    }

    

function layoutRail(){
  const rootRect = root.getBoundingClientRect();
  const sideRect = side?.getBoundingClientRect();
  if (!sideRect) return;

  ctas.forEach(cta => {
    const key = cta.getAttribute('data-rail');
    const marker = root.querySelector(`.webstory-pause[data-rail="${key}"]`)
                 || root.querySelector(`.webstory-part[data-rail="${key}"]`);
    if (!marker) return;

    const mr   = marker.getBoundingClientRect();
    const ctaH = cta.offsetHeight || 44;
    const yCenter = (mr.top + mr.height/2) - rootRect.top;  
    cta.style.top = `${Math.max(0, yCenter - ctaH/2)}px`;
  });
}



    
    let ticking = false;
    let scrollBound = false;
    const onScroll = () => updateStripe();

    const bindScroll = () => {
      if (scrollBound) return;
      window.addEventListener('scroll', onScroll, { passive:true });
      scrollBound = true;
    };

    const unbindScroll = () => {
      if (!scrollBound) return;
      window.removeEventListener('scroll', onScroll);
      scrollBound = false;
    };

    const syncScrollBinding = () => {
      if (!sectionScope) {
        bindScroll();
        updateStripe();
        return;
      }
      const active =
        sectionScope.classList.contains('is-inview') ||
        sectionScope.classList.contains('scrolled-active') ||
        sectionScope.classList.contains('is-dominant');
      if (active) {
        bindScroll();
        updateStripe();
      } else {
        unbindScroll();
      }
    };


    function updateStripe(){

  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    const r  = root.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    
    const NAV_H     = 100;  
    const START_PAD = 0;    
    const END_PAD   = NAV_H; 

    
    const total    = (r.height + vh - NAV_H) - START_PAD - END_PAD;
    const scrolled = ((vh - NAV_H) - r.top) - START_PAD;
    
    const SPEED = 1.3;

    let raw = (scrolled / total) * SPEED;   
    raw = Math.min(1, Math.max(0, raw));    

    
    root.style.setProperty('--stripe-fill', raw.toFixed(4));

    
    const railHeight = stripe.getBoundingClientRect().height || r.height;
    const fillY = raw * railHeight;

    ctas.forEach(cta => {
  const key    = cta.getAttribute('data-rail');
  const ctaTop = parseFloat(getComputedStyle(cta).top) || 0;
  const active = fillY >= (ctaTop + (cta.offsetHeight * 0.2));

  cta.classList.toggle('is-active', active);

  
  const pause = root.querySelector(`.webstory-pause[data-rail="${key}"]`);
  const label = cta.querySelector('.cta__label');
  if (label && pause) {
    const txt = (pause.textContent || '').trim();
    if (txt && label.textContent !== txt) label.textContent = txt;
  }

  
  const part = root.querySelector(`.webstory-part[data-rail="${key}"]`);
  if (part) part.classList.toggle('call-hot', active);
});


    ticking = false;
  });
}




    
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        e.target.classList.toggle('is-active', e.intersectionRatio >= 0.4);
      });
    }, { threshold: [0, .4, .8], rootMargin: '0px 0px -10% 0px' });
    parts.forEach(p => io.observe(p));

    
    bindActionLinks();
    bindHashLinks();

    const ro = new ResizeObserver(() => { layoutRail(); updateStripe(); });
    ro.observe(root);

    window.addEventListener('load',   () => { layoutRail(); updateStripe(); });
    window.addEventListener('resize', () => { layoutRail(); updateStripe(); }, { passive:true });
    if (sectionScope) {
      const sectionStateObserver = new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            syncScrollBinding();
            break;
          }
        }
      });
      sectionStateObserver.observe(sectionScope, { attributes: true, attributeFilter: ['class'] });
    }
    syncScrollBinding();

    
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => { layoutRail(); updateStripe(); });
    }
  })();
}
